import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";


const AboutS5 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>OMT <span>{t('Ценности')}</span></div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('Эти принципы определяют каждое наше решение.')}</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Инновации и технологии')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы используем передовые решения, автоматизированные механизмы и прозрачные смарт-контракты, чтобы обеспечить эффективный и безопасный запуск проектов.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Прозрачность и доверие')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Каждый участник и проект работает в понятной, честной и контролируемой среде, где правила ясны, а процессы прозрачны.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Взаимная ценность и рост')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы соединяем лучшие проекты с подготовленными участниками, создавая экосистему, где каждый получает реальные возможности для развития, прибыли и долгосрочного успеха.')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutS5;




